// @flow

import * as React from 'react';
import { useRifm } from 'rifm';
import { InputAdornment, FilledInput } from '@material-ui/core';
import { useUserData } from '../hooks/user-data.js';
import { useNumberFormat } from '../hooks/number-format.js';
import { NumberInput } from './number-input.js';

type Props = {|
  value: string,
  isFilled?: boolean,
  onChange: string => void,
  onBlur?: () => void,
|};

export const PriceInput = (props: Props): React.Node => {
  const {
    featureConfig: { displayCurrency, currencyAdornment },
  } = useUserData();
  let currencyProps = null;
  if (currencyAdornment === 'start') {
    currencyProps = {
      startAdornment: (
        <InputAdornment position="start">{displayCurrency}</InputAdornment>
      ),
    };
  } else {
    currencyProps = {
      endAdornment: (
        <InputAdornment position="end">{displayCurrency}</InputAdornment>
      ),
    };
  }

  const { accept, parse, format } = useNumberFormat({
    scale: 2,
    allowNegative: false,
  });
  const rifm = useRifm({
    accept,
    format,
    value: props.value,
    onChange: formatted => props.onChange(parse(formatted)),
  });

  return (
    <>
      {props.isFilled !== true ? (
        <NumberInput
          {...currencyProps}
          maxLength={20}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
        />
      ) : (
        <FilledInput
          {...currencyProps}
          css={{
            paddingLeft: 0,
            paddingRight: 0,
            '.MuiFilledInput-input': {
              textAlign: 'start',
              padding: '18.5px 0 19.5px',
            },
          }}
          value={rifm.value}
          onChange={rifm.onChange}
          onBlur={props.onBlur}
        />
      )}
    </>
  );
};
